import {
  PicTreeReviewSummaryHokuden,
  PicTreeCheckInHokuden,
  PicTreeMapHokuden,
  PicTreeReportSummaryHokuden,
  PicTreeGroupSummaryHokuden,
  PicTreeReviewByAssetTypeHokuden,
} from "pages";

export default {
  items: [
    {
      path: "/photos/group",
      name: "グループ登録",
      type: "link",
      icon: false,
      component: PicTreeGroupSummaryHokuden,
      sideBar: true,
      divider: true,
    },
    {
      path: "/game/pictree/hokuden/photos/overview",
      name: "概要",
      type: "link",
      icon: false,
      category: "撮影",
      component: PicTreeReviewSummaryHokuden,
      sideBar: true,
      divider: false,
    },
    {
      path: "/game/pictree/hokuden/photos/asset-type",
      name: "アセットタイプ別",
      type: "link",
      icon: false,
      component: PicTreeReviewByAssetTypeHokuden,
      sideBar: true,
      divider: true,
    },
    {
      path: "/game/pictree/hokuden/photos/map",
      name: "地図表示",
      type: "link",
      icon: false,
      component: PicTreeMapHokuden,
      sideBar: true,
      divider: false,
    },
    {
      path: "/game/pictree/hokuden/checkin",
      name: "チェックイン",
      type: "link",
      icon: false,
      component: PicTreeCheckInHokuden,
      sideBar: true,
      divider: false,
    },
    {
      path: "/game/pictree/hokuden/report/overview",
      name: "概要",
      type: "link",
      icon: false,
      category: "報告",
      component: PicTreeReportSummaryHokuden,
      sideBar: true,
      divider: false,
    },
  ],
};
